import { TableCell, TableRow } from '@mui/material';
import React from 'react';

const LuggageTableHeader = ({ columnDefs, UseToPayAsCOD }) => {
  const modifiedColumns = columnDefs
    // .filter(col => !(UseToPayAsCOD === 1 && col.field === "IsCOD"))
    .map(col => {
      if (UseToPayAsCOD === 1) {
        if (col.field === "IsTopay") return { ...col, headerName: "COD" };
        if (col.field === "IsTopayMan") return { ...col, headerName: "COD Manual" };
        if (col.field === "IsDDDV") return { ...col, headerName: "COD DDDV" };
      }
      return col;
    });

  return (
    <TableRow>
      {modifiedColumns.map((col, index) => (
        <TableCell
          key={`TH-${index}`}
          style={{
            ...col.headerSx,
            backgroundColor: '#DAEDFE',
            minHeight: '36px',
            fontSize: '12px',
            fontWeight: '600',
            color: '#444',
          }}
        >
          {col.headerName}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default LuggageTableHeader;
